import $ from "jquery";

// @see https://www.w3.org/WAI/tutorials/menus/application-menus/
// @see https://www.w3.org/WAI/tutorials/menus/application-menus-code/

let MAIN_CURRENT_INDEX = 0;
let MAIN_COUNT = 0;
let MAIN_OPEN = false;
let SUB_CURRENT_INDEX = 0;
let SUB_ITEMS = [];

const KEYS = {
  tab: 9,
  enter: 13,
  esc: 27,
  space: 32,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
};

const wrapIndex = function (index) {
  if (index === MAIN_COUNT) {
    index = 0;
  } else if (index < 0) {
    index = MAIN_COUNT - 1;
  }
  return index;
};

const navLinks = function () {
  return $('[data-js="pageHeaderNavLink"]');
};

const navLinkCurrent = function () {
  return navLinks().eq(MAIN_CURRENT_INDEX);
};

const navLinkCurrentSubMenuLink = function () {
  return navLinkCurrent()
    .find('[data-js="pageHeaderNavSubMenu"] a')
    .eq(SUB_CURRENT_INDEX);
};

const focus = function () {
  navLinkCurrent().focus();
};

const focusFirstSub = function () {
  SUB_CURRENT_INDEX = 0;
  navLinkCurrentSubMenuLink().focus();
};

const focusLastSub = function () {
  SUB_CURRENT_INDEX = SUB_ITEMS.length - 1;
  navLinkCurrentSubMenuLink().focus();
};

const focusNextSub = function () {
  SUB_CURRENT_INDEX =
    SUB_CURRENT_INDEX + 1 === SUB_ITEMS.length ? 0 : SUB_CURRENT_INDEX + 1;
  navLinkCurrentSubMenuLink().focus();
};

const focusPrevSub = function () {
  SUB_CURRENT_INDEX =
    SUB_CURRENT_INDEX === 0 ? SUB_ITEMS.length - 1 : SUB_CURRENT_INDEX - 1;
  navLinkCurrentSubMenuLink().focus();
};

const open = function () {
  navLinkCurrent().attr("aria-expanded", true);
  navLinkCurrent()
    .find('[data-js="pageHeaderNavSubMenu"]')
    .attr("aria-hidden", false);
  MAIN_OPEN = true;
  SUB_ITEMS = navLinkCurrent().find('[data-js="pageHeaderNavSubMenu"] a');
  SUB_CURRENT_INDEX = 0;
  $("body").addClass("is-flyout-open");
  navLinks()
    .filter(".menu-item--active-trail")
    .addClass("hide-active-indicator");
};

const closeAll = function () {
  navLinks().attr("aria-expanded", false);
  navLinks().find('[data-js="pageHeaderNavSubMenu"]').attr("aria-hidden", true);
  MAIN_OPEN = false;
  SUB_ITEMS = [];
  SUB_CURRENT_INDEX = 0;
  $("body").removeClass("is-flyout-open");
  navLinks()
    .filter(".menu-item--active-trail")
    .removeClass("hide-active-indicator");
};

$(document).on(
  "click",
  '[data-js="pageHeaderNavLink"]:not([data-flyout="false"]) > div:first-child',
  function (e) {
    if (
      MAIN_OPEN === true &&
      MAIN_CURRENT_INDEX === $(e.currentTarget.parentElement).index()
    ) {
      closeAll();
      focus();
    } else {
      closeAll();
      MAIN_CURRENT_INDEX = $(e.currentTarget.parentElement).index();
      open();
      focusFirstSub();
    }
  },
);

$(document).on("click", function (e) {
  if ($('[data-js="pageHeaderNavLinks"]').length) {
    const isClickInsideNav = $('[data-js="pageHeaderNavLinks"]')[0].contains(
      e.target,
    );
    if (!isClickInsideNav && MAIN_OPEN) {
      closeAll();
    }
  }
});

$(document).on("keydown", '[data-js="pageHeaderNavLinks"]', function (e) {
  let preventDefault = false;
  switch (e.keyCode) {
    case KEYS.tab:
      closeAll();
      MAIN_CURRENT_INDEX = 0;
      break;
    case KEYS.esc:
      if (MAIN_OPEN) {
        closeAll();
        focus();
      } else {
        MAIN_CURRENT_INDEX = 0;
        // TODO: find next focusable element
        navLinks().blur();
      }
      preventDefault = true;
      break;
    case KEYS.left:
      MAIN_CURRENT_INDEX = wrapIndex(MAIN_CURRENT_INDEX - 1);
      if (MAIN_OPEN) {
        closeAll();
        open();
        focusFirstSub();
      } else {
        focus();
      }
      preventDefault = true;
      break;
    case KEYS.right:
      MAIN_CURRENT_INDEX = wrapIndex(MAIN_CURRENT_INDEX + 1);
      if (MAIN_OPEN) {
        closeAll();
        open();
        focusFirstSub();
      } else {
        focus();
      }
      preventDefault = true;
      break;
    case KEYS.down:
      if (MAIN_OPEN) {
        focusNextSub();
      } else {
        open();
        focusFirstSub();
      }
      preventDefault = true;
      break;
    case KEYS.up:
      if (MAIN_OPEN) {
        focusPrevSub();
      } else {
        open();
        focusLastSub();
      }
      preventDefault = true;
      break;
    case KEYS.enter:
    case KEYS.space:
      if (!MAIN_OPEN) {
        open();
        focusFirstSub();
        preventDefault = true;
      }
      break;
  }
  if (preventDefault) {
    e.preventDefault();
    e.stopPropagation();
  }
});

$(function () {
  const $navLinks = navLinks();
  $navLinks
    .attr({
      "aria-haspopup": true,
      tabindex: -1,
    })
    .first()
    .attr({
      tabindex: 0,
    });
  $navLinks.find('[data-js="pageHeaderNavSubMenu"]').attr({
    "aria-hidden": true,
  });
  MAIN_COUNT = $navLinks.length;
});
